import { Button } from '@mui/material';
import {
  CustomSyncDisabledIcon,
  CustomSyncIcon,
} from '../../components/ScanItemViewer/styles';
import { useCameraStore } from './useCameraStore';
import {
  CompareModeEnum,
  useCompareStore,
} from '../CompareControls/useCompareStore';
import { ControlSection } from '../ui/ControlSection';

export const SyncControlsButton = () => {
  const { toggleSynced, isSynced } = useCameraStore();
  const { compareMode } = useCompareStore();

  const isDual = compareMode === CompareModeEnum.Dual;
  const isDisabled = !isDual;

  const content = isSynced ? (
    <>
      <CustomSyncDisabledIcon /> Unsync
    </>
  ) : (
    <>
      <CustomSyncIcon /> Sync
    </>
  );

  return (
    <ControlSection title='Sync mode'>
      <Button
        fullWidth
        size='small'
        variant={isSynced ? 'toggleActive' : 'toggleInactive'}
        onClick={toggleSynced}
        disabled={isDisabled}
        sx={{
          fontSize: '11px',
          fontWeight: 600,
          justifyContent: 'center',
          gap: '4px',
        }}
      >
        {content}
      </Button>
    </ControlSection>
  );
};
